import axios from "../utils/axios";

export const getBreakdownReasonDetails = () => {
    return axios.get(`/BreakdownReasonDetail/GetDetailedList`);
};

export const addBreakdownReasonDetail = (payload) => {
    return axios.post(`/BreakdownReasonDetail/Add`, payload);
};

export const updateBreakdownReasonDetail = (payload) => {
    return axios.post(`/BreakdownReasonDetail/Update`, payload);
};

export const deleteBreakdownReasonDetail = (payload) => {
    return axios.post(`/BreakdownReasonDetail/Delete`, payload);
};

export const getPlants = () => {
    return axios.get(`/Plant/GetList`);
};

export const getBreakDownReasonGroups = () => {
    return axios.get(`/BreakdownReasonGroup/GetList`);
};

export const getBreakdownReasonPlaceByGroupId = (payload) => {
    return axios.get(`/BreakdownReasonPlace/GetListByGroupId?breakdownGroupId=${payload}`);
};
